import { SITE_LOCALES } from '../nav-link';

/** Same host as `apps/landing/scripts/locales.mjs`. */
export const BASE_URL = 'https://ledgerly.download';

/**
 * The absolute URL of an app route in a given locale.
 *
 * `route` is the path without the locale prefix, the way the router sees it:
 * `/`, `/terms`, `/privacy`.
 *
 * A locale home is `/fr`, never `/fr/`. Firebase Hosting runs with
 * `trailingSlash: false` and 301s the slashed form, so a canonical or hreflang
 * pointing at `/fr/` points at a redirect, which Google will not honour.
 * English is the exception: `https://ledgerly.download/` is the canonical root
 * and does not redirect.
 */
export function absoluteUrl(localeCode: string, route: string): string {
  const locale = SITE_LOCALES.find((l) => l.code === localeCode);
  const prefix = !locale || locale.code === 'en' ? '' : locale.path;

  if (route === '/' || route === '') {
    return `${BASE_URL}${prefix || '/'}`;
  }

  return `${BASE_URL}${prefix}${route}`;
}
